namespace Matrix {

    @Serenity.Decorators.panel()
    export class SiteEntityDialog<TItem, TOptions> extends Serenity.EntityDialog<TItem, TOptions> {

        constructor(options?: TOptions) {
            super(options);
        }

        protected getInsertPermission() {
            return Q.tryGetText("Db." + this.getLocalTextPrefix() + ".Permissions.Insert");
        }

        protected getUpdatePermission() {
            return Q.tryGetText("Db." + this.getLocalTextPrefix() + ".Permissions.Update");
        }

        protected getDeletePermission() {
            return Q.tryGetText("Db." + this.getLocalTextPrefix() + ".Permissions.Delete");
        }

        protected get hasPendingChanges() {
            return !!(this.entity && this.entity[Workflow.ApprovalConsts.PendingOperationKey]);
        }

        protected updateInterface(): void {

            undoMadeReadOnly(this.byId('Form'));

            super.updateInterface();

            // show clone button if it is edit mode (not new)
            this.cloneButton.toggle(this.isEditMode());

            var hasSavePermission = this.hasSavePermission();
            var hasPendingChanges = this.hasPendingChanges;
            var viewMode = this.isViewMode();
            var isDeleted = this.isDeleted();

            this.cloneButton && this.cloneButton.toggleClass("disabled", !this.hasInsertPermission());
            this.saveAndCloseButton && this.saveAndCloseButton.toggleClass("disabled", !hasSavePermission || hasPendingChanges);
            this.saveAndCloseButton && this.saveAndCloseButton.toggle(!isDeleted && !viewMode);
            this.applyChangesButton && this.applyChangesButton.toggleClass("disabled", !hasSavePermission || hasPendingChanges);
            this.applyChangesButton && this.applyChangesButton.toggle(!isDeleted && !viewMode);
            this.deleteButton && this.deleteButton.toggleClass("disabled", !this.hasDeletePermission() || hasPendingChanges);
            this.deleteButton.toggle(this.isEditMode() && !isDeleted && !viewMode);

            this.toolbar.findButton(".edit-button").toggle(viewMode && hasSavePermission && !hasPendingChanges);

            if (hasPendingChanges || !hasSavePermission || viewMode) {
                makeReadOnly(this.byId("Form"));

                if (Q.startsWith(this.dialogTitle || '', 'Edit '))
                    this.dialogTitle = 'View ' + this.dialogTitle.substr(5);
            }
            else if (this.editClicked && Q.startsWith(this.dialogTitle || '', 'View ')) {
                this.dialogTitle = 'Edit ' + this.dialogTitle.substr(5);
            }

            var logCategory = this.byId("CreatedBy").closest(".category");
            var logVisible = this.isEditMode() || (logCategory.find('.category-anchor').text() != 'Version Info');
            this.byId("CreatedBy").closest(".category").toggle(logVisible);
            $('a.category-link:contains(Version Info)', this.propertyGrid.element).toggle(logVisible).next('span').toggle(logVisible);

            this.byId('EntityLinksButton').toggle(this.isEditMode());
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.byId('PendingChangesWarning').remove();
            if (this.hasPendingChanges) {
                var operation = this.entity[Workflow.ApprovalConsts.PendingOperationKey] as string;
                var alert = $('<div class="alert alert-danger" id="' + (this.idPrefix + "PendingChangesWarning") + '">' +
                    'This record has a pending ' + operation + ' operation that requires approval. ' +
                    'No further modifications are possible until it is approved / rejected. ' +
                    '<a href="javascript:;">Click here</a> to review the changes.</div>')
                    .prependTo(this.element);

                alert.find('a').on('click', () => {
                    var dlg = new Workflow.ApprovalDialog();
                    Serenity.SubDialogHelper.bindToDataChange(dlg, this, (e, dci) => {
                        if (operation.toLowerCase() == Workflow.ApprovalConsts.DeleteOperation.toLowerCase()) {
                            Serenity.SubDialogHelper.triggerDataChange(this);
                            if (dci.type != "REJECTED")
                                this.dialogClose();
                            else {
                                if (this.isNew())
                                    this.loadEntity({} as any);
                                else
                                    this.loadById(this.entityId);
                            }
                        }
                        else if (operation.toLowerCase() == Workflow.ApprovalConsts.UpdateOperation.toLowerCase()) {
                            Serenity.SubDialogHelper.triggerDataChange(this);
                            if (this.isNew())
                                this.loadEntity({} as any);
                            else
                                this.loadById(this.entityId);
                        }
                    });
                    dlg.execute(this.entity[Workflow.ApprovalConsts.PendingInstanceKey]);
                });
            }

            if (this.isEditMode()) {
                this.byId('EntityLinksList').children().each((x, el) => this.renderEntityLink($(el)));
            }
        }

        protected renderEntityLink(el: JQuery) {
            var a = el.html('<a class="dropdown-item" />').children();
            var link = el.data('link') as Data.EntityLinkRow;
            if (!link || !this.entity)
                return;

            var text = Q.microFormat(link.Caption || '?', this.entity, {});
            a.text(text);

            var nullValues = false;
            var url = Q.microFormat(link.Url || '?', this.entity, {
                handler: (token, data, offset, str) => {
                    var value = data[token];
                    if (value == null)
                        nullValues = true;
                    return TemplateUrlFormatter.microFormatUrlHandler(token, data, offset, str);
                }
            });

            if (nullValues) {
                a.hide();
                return;
            }

            if (url && Q.startsWith(url, '~/')) {
                url = Q.resolveUrl(url);
            }

            a.attr('href', url);

            var klass = link.Icon;
            if (klass) {
                if (Q.startsWith(klass, 'fa-')) {
                    klass = 'fa ' + klass;
                }
                else if (Q.startsWith(klass, 'glyphicon-')) {
                    klass = 'glyphicon ' + klass;
                }

                var i = $('<i></i>').addClass(klass).prependTo(a).after(' ');

                if (link.IconColor)
                    i.css('color', link.IconColor);
            }

            if (link.Target)
                a.attr('target', link.Target);
        }

        protected getEntityTitle() {
            var entityTitle = super.getEntityTitle();

            if (Q.startsWith(entityTitle, 'Edit ') && this.isViewMode() || !this.hasSavePermission())
                entityTitle = 'View ' + entityTitle.substr(5);

            return entityTitle;
        }

        protected getCloningEntity() {
            var entity = super.getCloningEntity();

            removeSystemFields(entity, this.getPropertyItems());

            return entity;
        }

        protected useViewMode() {
            return true;
        }

        protected getSaveOptions(callback) {
            var opt = super.getSaveOptions(callback);
            var oldError = opt.onError;

            opt.onError = (response) => {
                const mandatory = WorkflowCommentOption[WorkflowCommentOption.Mandatory];
                const optional = WorkflowCommentOption[WorkflowCommentOption.Optional];
                const approvalComment = Matrix.Workflow.ApprovalConsts.ApprovalComment;

                if (response && response.Error && response.Error.Code == "ApprovalRequired") {
                    Q.notifyWarning(response.Error.Message);
                    if (this.useViewMode())
                        this.editClicked = false;
                    if (this.isNew())
                        this.loadEntity({} as any);
                    else
                        this.loadById(this.entityId);
                    return;
                }
                else if (response && response.Error && (response.Error.Code === approvalComment + mandatory || response.Error.Code === approvalComment + optional) && !opt.request?.CustomData?.[Matrix.Workflow.ApprovalConsts.ChangeCommentKey]) {
                    const dlg = new Matrix.Workflow.ApprovalCommentDialog({
                        title: (this.isNew() ? "Insert" : "Update") + " Comment",
                        required: (response.Error.Code == approvalComment + mandatory) ? WorkflowCommentOption.Mandatory : WorkflowCommentOption.Optional
                    });

                    dlg.onSuccess = (comment) => {
                        opt.request.CustomData = {
                            ...(opt.request.CustomData ?? {}),
                            [Matrix.Workflow.ApprovalConsts.ChangeCommentKey]: comment
                        };

                        Q.serviceCall(opt);
                        dlg.dialogClose();
                    }

                    dlg.dialogOpen();
                    return;
                }
                if (oldError)
                    oldError(response);
                else
                    Q.ErrorHandling.showServiceError(response.Error);
            };

            return opt;
        }

        protected getDeleteOptions(callback): Serenity.ServiceOptions<Serenity.DeleteResponse> {
            var opt = super.getDeleteOptions(callback);
            var oldError = opt.onError;

            opt.onError = (response) => {
                const mandatory = WorkflowCommentOption[WorkflowCommentOption.Mandatory];
                const optional = WorkflowCommentOption[WorkflowCommentOption.Optional];
                const approvalComment = Matrix.Workflow.ApprovalConsts.ApprovalComment;

                if (response && response.Error && response.Error.Code == "ApprovalRequired") {
                    Q.notifyWarning(response.Error.Message);
                    if (this.isNew())
                        this.loadEntity({} as any);
                    else
                        this.loadById(this.entityId);
                    return;
                }
                else if (response && response.Error && (response.Error.Code === approvalComment + mandatory || response.Error.Code === approvalComment + optional) && !opt.request?.CustomData?.[Matrix.Workflow.ApprovalConsts.ChangeCommentKey]) {
                    const dlg = new Matrix.Workflow.ApprovalCommentDialog({
                        title: "Delete Comment",
                        required: (response.Error.Code == approvalComment + mandatory) ? WorkflowCommentOption.Mandatory : WorkflowCommentOption.Optional
                    });
                    dlg.onSuccess = (comment) => {
                        opt.service = this.getService() + '/Delete';
                        opt.request = {
                            EntityId: this.get_entityId(),
                            CustomData: {
                                ...(opt.request?.CustomData ?? {}),
                                [Matrix.Workflow.ApprovalConsts.ChangeCommentKey]: comment
                            }
                        };

                        Q.serviceCall(opt);
                        dlg.dialogClose();
                    }

                    dlg.dialogOpen();
                    return;
                }
                if (oldError)
                    oldError(response);
                else
                    Q.ErrorHandling.showServiceError(response.Error);
            };

            return opt;
        }

        protected initToolbar() {
            super.initToolbar();

            if (this.toolbar) {
                var entityName = this.getLocalTextPrefix();
                var links = Data.EntityLinkRow.getLookup().items.filter(x => x.EntityName == entityName);
                if (links.length) {
                    links.sort((a, b) => a.DisplayOrder > b.DisplayOrder ? 1 : (a.DisplayOrder < b.DisplayOrder ? -1 : 0));
                    var ul = $(`<div class="btn-group" id="${Q.attrEncode(this.idPrefix + "EntityLinksButton")}"><button class="tool-button entity-links-button icon-tool-button no-text" data-toggle="dropdown" aria-haspopup='true' aria-expanded="false">
<div class="button-outer"><span class="button-inner"> 
    <i class="fa fa-bars"></i></span>
</div></button><ul class="dropdown-menu" id="${Q.attrEncode(this.idPrefix + "EntityLinksList")}"></div>`)
                        .appendTo(this.toolbar.element.find('.buttons-inner').css('overflow', 'visible'))
                        .children('ul');

                    for (var i = 0; i < links.length; i++) {
                        $('<li><a class="dropdown-item"></a></li>').data('link', links[i]).appendTo(ul);
                    }
                }

            }
        }
    }

    export function makeReadOnly(container: JQuery) {
        container.find(".editor")
            .not('.made-readonly')
            .not('.s-StaticTextBlock')
            .not('.s-ReadOnlyDateTime')
            .each((i, e) => {
                var w = $(e).tryGetWidget(Serenity.Widget);
                if (w != null) {

                    if (w['get_readOnly']) {
                        if (w['get_readOnly']())
                            return;
                    }
                    else if ($(e).is('[readonly]') || $(e).is('[disabled]') || $(e).is('.readonly') || $(e).is('.disabled'))
                        return;

                    $(e).addClass('made-readonly');
                    Serenity.EditorUtils.setReadOnly(w, true);

                }
                else {
                    if ($(e).is('[readonly]') || $(e).is('[disabled]') || $(e).is('.readonly') || $(e).is('.disabled'))
                        return;
                    Serenity.EditorUtils.setReadonly($(e).addClass('made-readonly'), true);
                }
            });
    }

    export function undoMadeReadOnly(container: JQuery) {
        container.find(".editor.made-readonly")
            .removeClass('made-readonly').each((i, e) => {
                var w = $(e).tryGetWidget(Serenity.Widget);
                if (w != null)
                    Serenity.EditorUtils.setReadOnly(w, false);
                else
                    Serenity.EditorUtils.setReadonly($(e), false);
            });
    }

    export function removeSystemFields(entity: any, items?: Serenity.PropertyItem[]) {
        delete entity[Workflow.ApprovalConsts.PendingInstanceKey];
        delete entity[Workflow.ApprovalConsts.PendingOperationKey];
        delete entity['CreatedBy'];
        delete entity['CreatedWhen'];
        delete entity['UpdatedBy'];
        delete entity['UpdatedWhen'];
        delete entity['DefaultSortOrder'];
        delete entity['Version'];

        if (items) {
            for (var item of items) {
                if (item['cloneable'] != null && !item['cloneable']) {
                    delete entity[item.name];
                }
            }
        }
    }
}